import { render, staticRenderFns } from "./ImportedUsers.vue?vue&type=template&id=1b4dd390&"
import script from "./ImportedUsers.vue?vue&type=script&lang=ts&"
export * from "./ImportedUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports